import React, { useEffect, useRef, useState } from 'react';
import { ChevronDown, Check, X } from 'lucide-react';

/* Un filtro de la lista de leads en un botón: "Rubro: Todos ▾".

   Antes cada grupo era una fila entera de botones, y en una base con prospectos
   eran cinco filas antes de llegar a la tabla. Así entran todos en una línea, y
   el que tiene algo elegido se marca y se limpia con la cruz.

   `multiple`: se eligen varias opciones (el valor va separado por "|", como ya
   lo espera la API en `rubros`). `extra`: algo más dentro del desplegable, por
   ejemplo el selector de fecha de "Cargados". */
export default function FiltroDesplegable({ label, opciones, valor, onChange, multiple = false, extra = null, resumen = null }) {
  const [abierto, setAbierto] = useState(false);
  const caja = useRef(null);
  useEffect(() => {
    if (!abierto) return undefined;
    const fuera = (e) => { if (caja.current && !caja.current.contains(e.target)) setAbierto(false); };
    document.addEventListener('mousedown', fuera);
    return () => document.removeEventListener('mousedown', fuera);
  }, [abierto]);

  const elegidos = multiple ? String(valor || '').split('|').filter(Boolean) : (valor ? [valor] : []);
  const activo = elegidos.length > 0;
  const nombre = (v) => (opciones.find(([k]) => k === v) || [v, v])[1];
  const texto = resumen || (!activo ? 'Todos' : elegidos.length === 1 ? nombre(elegidos[0]) : `${elegidos.length} elegidos`);

  const elegir = (k) => {
    if (!multiple) { onChange(k === valor ? '' : k); setAbierto(false); return; }
    const n = elegidos.includes(k) ? elegidos.filter(x => x !== k) : [...elegidos, k];
    onChange(n.join('|'));
  };

  return (
    <div ref={caja} style={{ position: 'relative' }}>
      <button type="button" onClick={() => setAbierto(!abierto)}
        className={'btn btn-sm ' + (activo ? 'btn-primary' : 'btn-secondary')}
        style={{ gap: 6, maxWidth: 260 }}>
        <span style={{ color: activo ? undefined : 'var(--text-muted)', fontWeight: 500 }}>{label}:</span>
        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{texto}</span>
        {activo
          ? <X size={13} onClick={(e) => { e.stopPropagation(); onChange(''); setAbierto(false); }} style={{ flexShrink: 0 }} />
          : <ChevronDown size={13} style={{ flexShrink: 0 }} />}
      </button>
      {abierto && (
        <div style={{ position: 'absolute', top: 'calc(100% + 6px)', left: 0, zIndex: 60, minWidth: 220, maxWidth: 320, maxHeight: 340, overflowY: 'auto',
          background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 12, boxShadow: '0 12px 32px rgba(0,0,0,0.25)', padding: 6 }}>
          {opciones.map(([k, l]) => {
            const sel = elegidos.includes(k);
            return (
              <button key={k} type="button" onClick={() => elegir(k)}
                style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%', textAlign: 'left', padding: '8px 10px', borderRadius: 8, fontSize: 13,
                  background: sel ? 'var(--accent-glow)' : 'transparent', color: sel ? 'var(--accent)' : 'var(--text-primary)', fontWeight: sel ? 600 : 400 }}>
                <span style={{ width: 14, display: 'inline-flex' }}>{sel && <Check size={14} />}</span>{l}
              </button>
            );
          })}
          {extra && <div style={{ borderTop: '1px solid var(--border)', marginTop: 6, padding: '8px 6px 4px' }}>{extra}</div>}
        </div>
      )}
    </div>
  );
}
